import React, { useState, useEffect } from "react";
import {
  useHistory,
  useParams,
  NavLink,
  useRouteMatch,
  Route,
  Switch,
  Link,
} from "react-router-dom";

import Spinner from "../components/common/spinner/Spinner";
import Study from "../components/studyDetails/Study";
import { fetchStudyDetails } from "../services/apis";
import FakeData from "../pages/FakeData";

import Hedonic from "../components/studyDetails/Hedonic";
import Perception from "../components/studyDetails/Perception";

import "./StudyDetails.css";
import "../components/studyDetails/Study.css";

export default function StudyDetails() {
  const [studyDetails, setStudyDetails] = useState([]);
  let { path, url } = useRouteMatch();

  const params = useParams();
  var curCandidate = params.candidate;

  useEffect(() => {
    async function init() {
      try {
        const jwt = localStorage.getItem("jwt");

        var study = {
          Study_number: params.study_number,
          Country: params.country,
          Gender: params.gender,
          Client: params.client,
          Ownership: params.ownership,
        };
        var resultStudyDetails = await fetchStudyDetails(jwt, study);
        var resultStudyDetailsArr = [];
        resultStudyDetailsArr.push(resultStudyDetails);
        setStudyDetails(resultStudyDetailsArr);
      } catch (ex) {
        if (ex.response && ex.response.status === 401) {
          // history.push(`/`);
        }
      }
    }
    init();
  }, []);

  return (
    <div className="study">
      {studyDetails.length == 0 ? (
        <Spinner size="medium" color="grey" position="center" />
      ) : (
        <Study study={studyDetails} curCandidate={curCandidate} />
      )}
    </div>
  );
}
